import React from 'react';
import { Background, BackgroundVariant, Controls, ReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import MemberNode from './MemberNode';
import EditableOrganizationEdge from './EditableOrganizationEdge';

const nodeTypes = { member: MemberNode };
const edgeTypes = { editableOrganization: EditableOrganizationEdge };
const fitViewOptions = { padding: 0.15, maxZoom: 1 };

export default function OrganizationChart({ nodes, edges, onNodesChange, layoutVersion = 0, editingLines = true }) {
    return (
        <section className={`organization-chart${editingLines ? ' organization-chart--editing-lines' : ''}`} aria-label="Organization chart">
            <ReactFlow
                key={layoutVersion}
                nodes={nodes}
                onNodesChange={onNodesChange}
                edges={edges}
                nodeTypes={nodeTypes}
                edgeTypes={edgeTypes}
                fitView
                fitViewOptions={fitViewOptions}
                minZoom={0.25}
                maxZoom={2}
                nodesDraggable={!!onNodesChange}
                nodesConnectable={false}
                edgesReconnectable={false}
                elementsSelectable={false}
                deleteKeyCode={null}
                colorMode="light"
                proOptions={{ hideAttribution: true }}
            >
                <Background variant={BackgroundVariant.Dots} gap={20} size={1} color="#e8ecf0" />
                <Controls showInteractive={false} />
            </ReactFlow>
        </section>
    );
}
